/** @jsxImportSource davaux/client */
import { createEffect, createSignal } from 'davaux/client'

export default function ThemeToggle({
  variant = 'default',
  size = 'sm',
  lightLabel = '☀ Light',
  darkLabel = '☽ Dark',
}: {
  variant?: string
  size?: string
  lightLabel?: string
  darkLabel?: string
}) {
  const initial =
    typeof document !== 'undefined'
      ? ((document.documentElement.getAttribute('data-dv-color-scheme') as 'dark' | 'light') ??
        'light')
      : 'light'

  const [theme, setTheme] = createSignal<'dark' | 'light'>(initial)

  createEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.setAttribute('data-dv-color-scheme', theme())
    localStorage.setItem('dv-theme', theme())
  })

  return (
    <button
      type='button'
      class='dv-button'
      data-variant={variant}
      data-size={size}
      aria-label='Toggle color theme'
      onClick={() => setTheme(theme() === 'dark' ? 'light' : 'dark')}
    >
      <span class='dv-button-inner'>
        <span class='dv-button-label'>
          <span class='dv-theme-toggle-light'>{lightLabel}</span>
          <span class='dv-theme-toggle-dark'>{darkLabel}</span>
        </span>
      </span>
    </button>
  )
}
